import { isEmpty, isString } from 'lodash';

// NOTE: Allow email extensions to be up to 63 chars which is the max length extensions (TLD) can be
const notValidEmail = (value: string) => !isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i.test(value);

export function isInvalidEmail(value: string, invalidEmailAlert?: string) {
  if (notValidEmail(value)) {
    // `if` statement below is a safety net. This is a legacy code. We could face issues if for some reason we get a `invalidEmailAlert` that is string or undefined
    if (invalidEmailAlert && !isString(invalidEmailAlert)) return 'Invalid email address';

    return invalidEmailAlert || 'Invalid email address';
  }

  return false;
}
